const hostname = window.location.hostname;

let API_BASE_URL = "";
let FILE_BASE_URL = "";

if (hostname === "localhost" || hostname === "127.0.0.1") {
  API_BASE_URL = "http://localhost:3000/api";
  FILE_BASE_URL = "http://localhost:3000/upload";
} else if (hostname === "khattri.bank.in" || hostname === "www.khattri.bank.in") {
  API_BASE_URL = "https://khattri.bank.in/api";
  FILE_BASE_URL = "https://khattri.bank.in/upload";
} else if (hostname === "khattribank.com" || hostname === "www.khattribank.com") {
  API_BASE_URL = "https://www.khattribank.com/api";
  FILE_BASE_URL = "https://www.khattribank.com/upload";
}

const config = { API_BASE_URL, FILE_BASE_URL };

export default config;
